// extracted by mini-css-extract-plugin
export default {"wrapper":"Faq_wrapper__qex6X","header":"Faq_header__AVF6P","title":"Faq_title__E4cAx","content":"Faq_content__ez0nV"};